import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  left: Boolean,
  right: Boolean,
  top: Boolean,
  bottom: Boolean,
},
  setup(__props) {

const props = __props



const position = computed(() => {
  if (props.left) {
    return {
      anchor: 'center left' as const,
      self: 'center right' as const,
    }
  } else if (props.right) {
    return {
      anchor: 'center right' as const,
      self: 'center left' as const,
    }
  } else if (props.top) {
    return {
      anchor: 'top middle' as const,
      self: 'bottom middle' as const,
    }
  } else if (props.bottom) {
    return {
      anchor: 'bottom middle' as const,
      self: 'top middle' as const,
    }
  }

  return null
})

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createBlock(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_unref(position))), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})